"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PROMOBAR_COLOR = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
require("./PromoBar.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const PROMOBAR_COLOR = exports.PROMOBAR_COLOR = {
  PINK: 'pink',
  BLUE: 'blue',
  PINK_LIGHT: 'pink-light'
};
const PromoBar = ({
  components,
  backgroundColor
}) => {
  const bgColor = backgroundColor || PROMOBAR_COLOR.PINK_LIGHT;
  const className = `container PromoBar promoBar-bgColor-${bgColor}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
      className: "promoBarTextInfo"
    }))
  });
};
PromoBar.propTypes = {
  /**
   * {
   *  "info": "Estructura de componentes de PromoBar",
   *  "kind": "both",
   *  "beautifulName": "subcomponentes de promobar"
   * }
   */
  components: _propTypes.default.shape({
    'TextInfo-1': _propTypes.default.object.required
  }),
  /**
   * {
   *  "info": "Especifica el color de fondo de dicha banda",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  backgroundColor: _propTypes.default.string
};
PromoBar.defaultProps = {
  backgroundColor: PROMOBAR_COLOR.PINK
};
var _default = exports.default = PromoBar;

//# sourceMappingURL=index.js.map